import { AxiosRequestConfig } from "axios";
import { axiosUsers } from "../../config/axios";

export const isUserAuthenticated = async () => {

    let error:any;
    
    try {

        const user = localStorage.getItem('user')
        console.log('USUARIO!!!: ', user, 'EN BOOL: ', !!user)
        if( !user ) return error.sendCatch;
        const parsed_user = JSON.parse(user);
        console.log('user parseado: ', parsed_user)
        const token = parsed_user.usuario.token;
        
        const axiosRequest:AxiosRequestConfig = { 
            url: 'v5.0.1/api',
            method: "post",
            data: {
                fname: 'getUser'
            },
            headers: { 'authorization': token }
        };
        const { data } = await axiosUsers(axiosRequest);

        console.log('resultado de data', data)

        if( data ) return true;
        
        return false;
        
    } catch (e: any) {
        console.log('HUBO UN ERROR EN DATA: ',e,e.response)
        return false;
    
    }

}

export const isRedirectAvaiable = async ( history: any ) => {
    
    try {
        const redirect = localStorage.getItem('redirect');
        if( redirect && redirect.length ){
            await history.push(redirect);
            localStorage.removeItem('redirect');
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }

}















